import { render, staticRenderFns } from "./DeerVelveting.vue?vue&type=template&id=0a4ef62e&"
import script from "./DeerVelveting.vue?vue&type=script&lang=js&"
export * from "./DeerVelveting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports